import map from "./map";
import * as topBar from "./topbar";
import * as window from "./window";

export default {
    window,
    topBar,
    map,
};
